'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'border-all';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f84c';
var svgPathData = ['M48 96l0 136 152 0 0-152-136 0c-8.8 0-16 7.2-16 16zm0 184l0 136c0 8.8 7.2 16 16 16l136 0 0-152-152 0zM248 80l0 152 152 0 0-136c0-8.8-7.2-16-16-16L248 80zm0 200l0 152 136 0c8.8 0 16-7.2 16-16l0-136-152 0z', 'M384 80c8.8 0 16 7.2 16 16l0 136-152 0 0-152 136 0zm16 200l0 136c0 8.8-7.2 16-16 16l-136 0 0-152 152 0zM200 232L48 232 48 96c0-8.8 7.2-16 16-16l136 0 0 152zM48 280l152 0 0 152-136 0c-8.8 0-16-7.2-16-16l0-136zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBorderAll = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;